module.exports = __webpack_public_path__ + "static/media/undraw_Mobile_login_re_9ntv 1.dc2dfc35.svg";